export interface PlanFeature {
  messages: number;
  tokens: number;
}

export interface PlanFeatureItem {
  key: string;
  included: boolean;
}

export interface Plan {
  key: string;
  name: string;
  duration: number;
  features: PlanFeature;
  description: string;
  highlighted: boolean;
  price: string;
  amount: number;
  extraFeatures: PlanFeatureItem[];
}

export const plans: Plan[] = [
  {
    key: "basic",
    name: "plans.name.basic",
    duration: 30,
    features: { messages: 1000, tokens: 500000 },
    description: "plans.description.basic",
    highlighted: false,
    price: "199",
    amount: 199,
    extraFeatures: [
      { key: "plans.feature.textResponse", included: true },
      { key: "plans.feature.voiceResponse", included: true },
      { key: "plans.feature.imageResponse", included: false },
      { key: "plans.feature.documentResponse", included: false },
    ],
  },
  {
    key: "pro",
    name: "plans.name.pro",
    duration: 30,
    features: { messages: 5000, tokens: 2000000 },
    description: "plans.description.pro",
    highlighted: true,
    price: "499",
    amount: 499,
    extraFeatures: [
      { key: "plans.feature.textResponse", included: true },
      { key: "plans.feature.voiceResponse", included: true },
      { key: "plans.feature.imageResponse", included: true },
      { key: "plans.feature.documentResponse", included: false },
    ],
  },
  {
    key: "enterprise",
    name: "plans.name.enterprise",
    duration: 30,
    features: { messages: 20000, tokens: 10000000 },
    description: "plans.description.enterprise",
    highlighted: false,
    price: "1499",
    amount: 1499,
    extraFeatures: [
      { key: "plans.feature.textResponse", included: true },
      { key: "plans.feature.voiceResponse", included: true },
      { key: "plans.feature.imageResponse", included: true },
      { key: "plans.feature.documentResponse", included: true },
    ],
  },
];

export function planNameToKey(name: string): string {
  const lower = name?.toLowerCase() || "";
  if (lower === "basic") return "plan.basic";
  if (lower === "pro") return "plan.pro";
  if (lower === "enterprise") return "plan.enterprise";
  return lower || name;
}